export default "__VITE_ASSET__f4390dcc__"